/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "@mui/material/Table";
import DataTable from "../../examples/Tables/DataTable";
import data from "../dashboard/components/Projects/data";
import useApi from "../../components/Utils/api";
import MDInput from "../../components/MDInput";
import toast from "react-hot-toast";
import subDays from "date-fns/subDays";
import startOfMonth from "date-fns/startOfMonth";
import addMonths from "date-fns/addMonths";
import endOfMonth from "date-fns/endOfMonth";
import { useNavigate } from "react-router-dom";
import Icon from "@mui/material/Icon";
import BulkAssignMerchant from "./bulk-assign";
import Papa from 'papaparse';
import PermissionControl from "../../components/Utils/PermissionControl";
import MerchantStatusChangeSelectField from "../../components/MerchantStatusChangeSelectField";
import MerchantSettlementStatusChangeSelectField from "../../components/MerchantSettlementStatusChangeSelectField";
import VisibilityIcon from '@mui/icons-material/Visibility';

function Merchants() {
  const { merchantTablecolumns } = data();
  const [merchants, setMerchants] = useState([]);
  const [unAssignedMerchants, setUnAssignedMerchants] = useState([]);
  const [merchantGroups, setMerchantGroups] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const api = useApi();
  const getMerchants = () => {
    const data = {
      "ownerName": "",
      "mid": "",
      "referenceId": ""
    };
    api.post("merchant/browse",data)
      .then((response) => {
        if(response.data.statusCodeValue === 200) {
            const modifiedData = response.data.body.map(item => {
                const view = (
                    <PermissionControl permission={{ restrict: true, module: "Merchants", subModule: "UpdateMerchantStatus" }}>
                        <VisibilityIcon onClick={() => rowHandler({ original: item })} />
                    </PermissionControl>
                );
                const action = (
                    <PermissionControl permission={{ restrict: true, module: "Merchants", subModule: "UpdateMerchantStatus" }}>
                        <MerchantStatusChangeSelectField value={item.status} index={item.mid} />
                    </PermissionControl>
                );
                const settlementAllowed = (
                    <PermissionControl permission={{ restrict: true, module: "Merchants", subModule: "UpdateSettlementStatus" }}>
                        <MerchantSettlementStatusChangeSelectField value={item.isSettlementAllowed} index={item.mid} />
                    </PermissionControl>
                );
                return { ...item, action, settlementAllowed, view };
            });
            setMerchants(modifiedData);
        } else {
          toast.error(response.data.error);
        }
      })
      .catch((error) => {
          if (error.response && error.response.status === 403) {
              toast.error("You do not have permission to perform this action.");
              return;
          }
        console.log(error.response.data);
      })
  }
    const getMerchantGroups = () => {
        api.get("admin/browseMerchantGroup")
            .then((response) => {
                if(response.data.statusCodeValue === 200) {
                    setMerchantGroups(response.data.body);
                } else {
                    toast.error(response.data.error);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 403) {
                    toast.error("You do not have permission to perform this action.");
                    return;
                }
                console.log(error.response.data);
            })
    }
    const getUnAssignedMerchants = () => {
        const data = {
            "ownerName": "",
            "mid": "",
            "referenceId": "T2PAY"
        };
        api.post("merchant/browse",data)
            .then((response) => {
                if(response.data.statusCodeValue === 200) {
                    setUnAssignedMerchants(response.data.body);
                } else {
                    toast.error(response.data.error);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 403) {
                    toast.error("You do not have permission to perform this action.");
                    return;
                }
                console.log(error.response.data);
            })
    }

    const generateCSV = () => {
      if (merchants.length === 0) {
        return '';
      }
    
      // Filter out the first column and the "Action" column
      const filteredColumns = merchantTablecolumns.filter(
        (column, index) => column.Header !== "Action" && index !== 0
      );
    
      // Extract headers for CSV from the filtered columns
      const headers = filteredColumns.map(column => column.Header);
    
      // Map the merchants' data according to the filtered columns
      const merchantsWithFilteredColumns = merchants.map(item => {
        return filteredColumns.map(column => {
          // For "Settlement Allowed", fetch the raw value
          if (column.Header === "Settlement Allowed") {
            return item.isSettlementAllowed === "1" ? "Allowed" : "Not Allowed";
          }
    
          // General handling for other columns
          const accessor = column.accessor;
          const value = typeof accessor === 'function' ? accessor(item) : item[accessor];
          return value;
        });
      });
    
      // Generate the CSV data using Papa.parse
      const csvData = [headers, ...merchantsWithFilteredColumns];
    
      return Papa.unparse(csvData, {
        quotes: true,
      });
    };
    
    
  
    const handleDownloadCSV = () => {
      if (merchants.length === 0) {
        toast.error("No records found to download.");
        return;
      }
  
      const csvData = generateCSV();
  
      const currentDate = new Date().toISOString().slice(0, 10);
      const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
      const dateTimeString = `${currentDate}_${currentTime}`;
  
      const fileName = `Merchants_${dateTimeString}.csv`;
  
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
  

  useEffect(() => {
    getMerchants();
    getUnAssignedMerchants();
    getMerchantGroups();
  },[]);

  const rowHandler = (pageRow)  => {
    // console.log("triggered", pageRow)
    navigate(`/merchants/${pageRow.original.mid}`, {
      state: pageRow.original
    })
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid container justifyContent="flex-end">
              <PermissionControl permission={{ restrict: true, module: "Merchants", subModule: "AssignToGroup" }}>
                  <MDButton variant="gradient" onClick={() => setOpen(true)} color="info" style={{marginRight: "24px", marginBottom: "12px"}}>
                      Assign to Merchant Group
                  </MDButton>
              </PermissionControl>
              {/*<MDButton variant="gradient" onClick={() => navigate('/merchants/new')} color="info" style={{marginRight: "24px", marginBottom: "12px"}}>*/}
              {/*    Add Merchant*/}
              {/*</MDButton>*/}
          </Grid>
          <Grid item xs={12} lg={12}>
          <MDButton variant="gradient" onClick={handleDownloadCSV} color="info" style={{marginRight: "24px", marginBottom: "12px"}}>
                  Export
              </MDButton>
            <DataTable
              table={{ columns : merchantTablecolumns, rows : merchants }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
            />
          </Grid>
        </Grid>
      </MDBox>
        <BulkAssignMerchant setOpen={setOpen} open={open} unAssignedMerchants={unAssignedMerchants} merchantGroups={merchantGroups} getUnAssignedMerchants={getUnAssignedMerchants} />
      <Footer />
    </DashboardLayout>
  );
}

export default Merchants;
